import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight, Star } from "lucide-react";

function Hero() {
  const [currentSlide, setCurrentSlide] = useState(0);

  const carouselImages = [
    "/images/home-page-carousel/1.jpeg",
    "/images/home-page-carousel/2.jpg",
    "/images/home-page-carousel/3.jpeg",
    // "/images/home-page-carousel/4.jpeg",
    // "/images/home-page-carousel/5.png",
    "/images/home-page-carousel/6.jpeg",
    "/images/home-page-carousel/7.png",
  ];

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide(
      (prev) => (prev - 1 + carouselImages.length) % carouselImages.length,
    );
  };

  useEffect(() => {
    const timer = setInterval(nextSlide, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section
      id="home"
      className="pt-16 bg-gradient-to-r from-purple-50 to-pink-50 min-h-screen flex items-center"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_3fr] gap-12 items-center">
          <div className="text-center lg:text-left">
            <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-6">
              Craft Your Life with
              <span className="text-purple-600"> Srilatha Rakesh</span>
            </h1>
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              Unlock your potential and create the life you've always dreamed
              of. I'm here to guide you through every step of your
              transformation journey.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              {/* <button className="bg-purple-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors flex items-center justify-center">
                Start Your Journey
                <ArrowRight className="ml-2 h-5 w-5" />
              </button> */}
              {/* <button className="border-2 border-purple-600 text-purple-600 px-8 py-3 rounded-lg font-semibold hover:bg-purple-50 transition-colors">
                Learn More
              </button> */}
            </div>
            <div className="flex items-center justify-center lg:justify-start mt-8 space-x-4">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <Star
                    key={i}
                    className="h-5 w-5 text-yellow-400 fill-current"
                  />
                ))}
              </div>
              <span className="text-gray-600">500+ Lives Transformed</span>
            </div>
          </div>
          <div className="relative">
            {/* <div className="relative z-10">
              <img
                src="/images/srilatha.rakesh.official.jpeg"
                alt="Life Coach"
                className="rounded-2xl shadow-2xl w-full max-w-md mx-auto"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-purple-200 to-pink-200 rounded-2xl transform rotate-6 opacity-30 "></div> */}

            <div className="absolute inset-0 bg-gradient-to-r from-purple-200 to-pink-200 rounded-2xl transform rotate-6 opacity-30 "></div>

            <div className="relative w-full max-w-4xl mx-auto mb-12 rounded-3xl overflow-hidden shadow-2xl">
              <div className="relative h-96 md:h-[500px]">
                {/* Images */}
                {carouselImages.map((image, index) => (
                  <div
                    key={index}
                    className={`absolute inset-0 transition-opacity duration-700 ${
                      index === currentSlide ? "opacity-100" : "opacity-0"
                    }`}
                  >
                    <img
                      src={image}
                      alt={`Coaching session ${index + 1}`}
                      className="w-full h-full object-cover"
                    />
                    {/* <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div> */}
                  </div>
                ))}

                {/* Previous Button */}
                <button
                  onClick={prevSlide}
                  className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-slate-800 p-3 rounded-full shadow-lg transition transform hover:scale-110"
                  aria-label="Previous slide"
                >
                  <ChevronLeft size={24} />
                </button>

                {/* Next Button */}
                <button
                  onClick={nextSlide}
                  className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/80 hover:bg-white text-slate-800 p-3 rounded-full shadow-lg transition transform hover:scale-110"
                  aria-label="Next slide"
                >
                  <ChevronRight size={24} />
                </button>

                {/* Dots Indicator */}
                <div className="absolute bottom-4 left-1/2 -translate-x-1/2 flex space-x-2">
                  {carouselImages.map((_, index) => (
                    <button
                      key={index}
                      onClick={() => setCurrentSlide(index)}
                      className={`w-3 h-3 rounded-full transition-all ${
                        index === currentSlide
                          ? "bg-white w-8"
                          : "bg-white/50 hover:bg-white/75"
                      }`}
                      aria-label={`Go to slide ${index + 1}`}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Hero;
